import { LoadingButton } from '../buttons/LoadingButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { mintOptions } from 'src/web3/survivor';
import { GradientCheckbox } from '../gradients/GradientCheckbox';
import { useState } from 'react';
import { GradientIcon } from '../gradients/GradientIcon';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { CryptoChain } from 'src/util/CryptoChain';
import { Link } from '../Link';
// import { executeFunction } from 'src/firebaseCloud';
import { DialogCentered } from '../DialogCentered';

type ConfirmMintProps = {
  open: boolean;
  handleClose: () => void;
  title: string;
  chainId: number;
  mintPrice: { price: number; currency: string };
};

export const ConfirmMint = ({
  handleClose,
  open,
  title,
  chainId,
  mintPrice,
}: ConfirmMintProps) => {
  const [error, setError] = useState<string | null>(null);
  const [hash, setHash] = useState('');

  const [checked, setChecked] = useState(false);
  const handleConfirm = async () => {
    const options = mintOptions({
      price: mintPrice.price,
      collectionTitle: title,
      quantity: 1,
    });
    try {
      // const result = await executeFunction({
      //   chainId: `${chainId}`,
      //   functionName: options.functionName,
      //   abi: options.abi,
      //   address: options.contractAddress,
      //   msgValue: `${options.msgValue}`,
      // });
      // setHash(result.data.result);
    } catch (error) {
      console.dir(error);
      const message = (error as { message: string }).message || 'Unknown';
      setError(message);
    }
  };
  return (
    <DialogCentered open={open} onClose={handleClose}>
      {!error && !hash ? (
        <>
          <Typography variant="h5" sx={{ textAlign: 'center' }}>
            Are you sure you want to mint {title} for{' '}
            {mintPrice.price / 10 ** 18} {mintPrice.currency}?
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', mt: 4 }}>
            <Typography variant="body2" sx={{ fontWeight: 500, fontSize: 14 }}>
              I have reviewed this mint and understand that blockchain
              transactions are irreversible.
            </Typography>
            <GradientCheckbox
              color="primary"
              checked={checked}
              onClick={() => setChecked((prev) => !prev)}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 2,
              width: '100%',
            }}
          >
            <LoadingButton
              disabled={!checked}
              onClick={handleConfirm}
              variant="contained"
              size="large"
              color="secondary"
              fullWidth
              sx={
                !checked
                  ? { mt: 4, background: 'none', height: 40 }
                  : { mt: 4, height: 40 }
              }
            >
              Mint Now
            </LoadingButton>
            <Button
              onClick={handleClose}
              variant="outlined"
              size="large"
              color="error"
              fullWidth
              sx={{ mt: 4, height: 40 }}
            >
              Cancel
            </Button>
          </Box>
        </>
      ) : error ? (
        <>
          <Typography variant="h5">There has been an error.</Typography>
          <Typography>{error}</Typography>
        </>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <GradientIcon
            sx={{ width: 100, height: 100 }}
            IconComponent={CheckCircle}
            gradientColor="secondary.horizontal"
          />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h5">Success</Typography>
            <Typography variant="h6">
              Your mint for {title} has been successful!
            </Typography>
            <Typography>
              You can view your transaction{' '}
              <Link
                href={`${CryptoChain.from(chainId).explorerTransactionLink(
                  hash,
                )}`}
              >
                here
              </Link>
              .
            </Typography>
            <Typography>
              Your new item will appear in your{' '}
              <Link href="/profile/inventory">inventory</Link> soon
            </Typography>
          </Box>
        </Box>
      )}
    </DialogCentered>
  );
};
